import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from '../../axios';
import config from '../../config';
import './Blog.css';

const BlogAdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const backend_url = config.backend_url;

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!password) {
      setError('Lösenord krävs');
      return;
    }
    
    try {
      setLoading(true);
      setError('');
      
      const response = await axios.post(
        `${backend_url}/blog/admin/login`,
        { password },
        { withCredentials: true }
      );
      
      if (response.data.success) {
        // Set session storage to indicate admin logged in
        sessionStorage.setItem('blog_admin_logged_in', 'true');
        history.push('/adminblog/posts');
      } else {
        setError('Autentisering misslyckades');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Fel lösenord eller serverfel');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="blog-admin-login">
      <h2 className="blog-admin-title">Blogg Admin</h2>
      
      {error && <div className="error-message">{error}</div>}
      
      <form className="blog-admin-form" onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="Lösenord"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        
        <button type="submit" disabled={loading}>
          {loading ? 'Loggar in...' : 'Logga in'}
        </button>
      </form>
    </div>
  );
};

export default BlogAdminLogin; 